import React from "react";
import "./ChangeViewBtn.css";

const ChangeViewBtn = ({ onChangeViewBtnClick, changeViewData }) => {
  return (
    <div className="afisha_change-view_btn_container">
      {Object.keys(changeViewData).map((key, i) => (
        <button
          key={i}
          className={`afisha_btn${changeViewData[key].classObject}`}
          onClick={() => onChangeViewBtnClick(changeViewData[key].id)}
        >
          {changeViewData[key].text}
        </button>
      ))}
    </div>
  );
};

export default ChangeViewBtn;



// WEBPACK FOOTER //
// ./src/components/Events/ChangeViewBtn.js